import styled from "styled-components"

// TODO add Icon & CSS
export default function MedInstruction({margin, icon, text, iconStyle}) {
  return(
    <Container style={{margin: margin}}>
      {icon &&
        <Icon
          style={iconStyle}
          src={icon}
          height={26}
          width={18}
        />
      }
      <Text>{text}</Text>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
`

const Icon = styled.img`
  display: block;
  flex-shrink: 0;
`

const Text = styled.p`
  font-family: Abraham, Regular;
  font-size: 19px;
  margin: 0;
`